import {PasswordInputStyled} from "@/components/UI/Form/Inputs/PasswordInput/PasswordInput.styled";

const PasswordInput = ({...props}) => {
    return (
        <PasswordInputStyled {...props} inputProps={{type: 'password'}}/>
    );
};

export default PasswordInput;